import { render, staticRenderFns } from "./dirsItem.vue?vue&type=template&id=79769259&scoped=true&"
import script from "./dirsItem.vue?vue&type=script&lang=js&"
export * from "./dirsItem.vue?vue&type=script&lang=js&"
import style0 from "./dirsItem.vue?vue&type=style&index=0&id=79769259&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79769259",
  null
  
)

export default component.exports